import { window as $window } from "global";

// a function that determines if a DOM element is visible to the user or not
export const isVisible = (element: HTMLElement) => {
    return !!(
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
    );
};

// A debounce function that takes a function and a delay as parameters
export function debounce(func: Function, delay: number) {
    // A timer variable to track the delay period
    let timer: number;

    // Return a function that takes arguments
    const debouncedFunction = function (this: any, ...args: any) {
        // Clear the previous timer if any
        $window.clearTimeout(timer);
        // Set a new timer that will execute the function after the delay period
        timer = $window.setTimeout(() => {
            // Apply the function with arguments
            func.apply(this, args);
        }, delay);
    };

    return debouncedFunction;
}

// A throttle function that takes a function and an interval as parameters
export function throttle(func: Function, interval: number) {
    // A flag variable to track whether the function is running or not
    let isRunning = false;

    // Return a function that takes arguments
    const throttledFunction = function (this: any, ...args: any) {
        // If the function is not running
        if (!isRunning) {
            // Set the flag to true
            isRunning = true;
            // Apply the function with arguments
            func.apply(this, args);
            // Set a timer that will reset the flag after the interval
            $window.setTimeout(() => {
                // Set the flag to false
                isRunning = false;
            }, interval);
        }
    };

    return throttledFunction;
}
